import { useEffect, useCallback } from 'react';
import { useBoolean } from 'customHooks/boolean';

const getMenuPosition = (rect, { x, y }) => {
  const menuStyles = {
    top: y,
    left: x
  };

  const { innerWidth, innerHeight } = window;

  if (y + rect.height > innerHeight) {
    menuStyles.top -= rect.height;
  }

  if (x + rect.width > innerWidth) {
    menuStyles.left -= rect.width;
  }

  if (menuStyles.top < 0) {
    menuStyles.top =
      rect.height < innerHeight ? (innerHeight - rect.height) / 2 : 0;
  }

  if (menuStyles.left < 0) {
    menuStyles.left =
      rect.width < innerWidth ? (innerWidth - rect.width) / 2 : 0;
  }

  return menuStyles;
};

const useContextMenu = elementRef => {
  const [
    isMenuVisible,
    { setFalse: setMenuClose, setTrue: setMenuShow }
  ] = useBoolean();

  const setPosition = useCallback(
    ({ top, left }) => {
      if (!elementRef.current) return;
      elementRef.current.style.left = `${left}px`;
      elementRef.current.style.top = `${top}px`;
      setMenuShow();
    },
    [elementRef, setMenuShow]
  );

  const windowClickHanlder = useCallback(
    e => {
      if (isMenuVisible) setMenuClose();
    },
    [isMenuVisible, setMenuClose]
  );

  const windowContextmenuHandler = useCallback(
    e => {
      e.preventDefault();
      const rect = elementRef.current.getBoundingClientRect();
      const { top, left } = getMenuPosition(rect, { x: e.pageX, y: e.pageY });
      setPosition({ top, left });
      return;
    },
    [elementRef, setPosition]
  );

  useEffect(() => {
    window.addEventListener('click', windowClickHanlder);
    window.addEventListener('contextmenu', windowContextmenuHandler);
    return () => {
      window.removeEventListener('click', windowClickHanlder);
      window.removeEventListener('contextmenu', windowContextmenuHandler);
    };
  }, [elementRef, windowClickHanlder, windowContextmenuHandler]);

  return [isMenuVisible];
};

export default useContextMenu;
